module.exports = __webpack_public_path__ + "static/media/gyFeelLogo13.b96aaaf2.png";